import { createContext, useContext } from 'react';
import type { ZagruForm } from '../hooks/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyZagruForm = ZagruForm<any>;

export const FormContext = createContext<AnyZagruForm | null>(null);
FormContext.displayName = 'ZagruFormContext';

/** Returns the enclosing form; throws when used outside `<Form>`. */
export function useFormContext<T = unknown>(): ZagruForm<T> {
  const form = useContext(FormContext);
  if (!form) {
    throw new Error('useFormContext must be used inside <Form form={...}>. Wrap the component in a Form or pass the form instance explicitly.');
  }
  return form as ZagruForm<T>;
}

/** Returns the enclosing form or `null` when rendered standalone. */
export function useOptionalFormContext<T = unknown>(): ZagruForm<T> | null {
  return useContext(FormContext) as ZagruForm<T> | null;
}
